import { render } from "./chooseemail.vue?vue&type=template&id=53d153fe&scoped=true"
import script from "./chooseemail.vue?vue&type=script&lang=js"
export * from "./chooseemail.vue?vue&type=script&lang=js"

import "./chooseemail.vue?vue&type=style&index=0&id=53d153fe&lang=scss&scoped=true"
import "./chooseemail.vue?vue&type=style&index=1&id=53d153fe&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d153fe"]])

export default __exports__